import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';

import RenderField from '../../components/RenderField';
import { required } from '../../utilities/validations';
import OtpTimer from '../../components/OtpTimer';
import { resendBusinessOTPRequest,resendOTPRequest } from '../../store/signup/signupAction';

/**
 * OTP form component
 * @param {*} props
 */
const OtpForm = (props) => {
    const {
        handleSubmit,
        pristine,
        submitting,
        verifyOTP,
        otpVerified,
        resendBusinessOTPRequest,
        basicData,
        otpText = 'Verify',
        formId = null,
        otpLabel = 'Enter the verification code to complete the verification',
        disableForm = false,currentStep,resendOTPRequest
    } = props;

    const [showCounter, setShowCounter] = useState(false);
    /**
     * Resend opt function
     */
    const resendOTP = () => {
        if (currentStep === 2) {
            resendOTPRequest({ formID: get(basicData, 'form_id', formId) }).then(
                (res) => {
                    if (res.status === 'success') {
                        setShowCounter(true);
                    }
                }
            )
        } else {
            resendBusinessOTPRequest({ formID: get(basicData, 'form_id', formId) }).then(
                (resp) => {
                    if (resp.status === 'success') {
                        setShowCounter(true);
                    }
                }
            );
        }

    };
    return (
        <>
            <form onSubmit={handleSubmit(verifyOTP)}>
                <div className="form-group input-btn-group">
                    <Field
                        name="otp"
                        component={RenderField}
                        type="text"
                        placeholder="Verification Code"
                        validate={required}
                        label={otpLabel}
                        className="form-control"
                        disabled={disableForm}
                    />

                    <button
                        className={`btn-tertiary ${(pristine ||
                                submitting ||
                                otpVerified ||
                                disableForm) &&
                            'off'
                            }`}
                        type="submit"
                        disabled={
                            pristine || submitting || otpVerified || disableForm
                        }
                    >
                        {otpText}
                    </button>
                </div>

                {otpVerified && (
                    <span className="green">
                        Verification code has been verified successfully
                    </span>
                )}
            </form>

            {showCounter ? (
                <OtpTimer setCounterFlag={setShowCounter} />
            ) : (
                <p>
                    Verification code not received?
                    <button
                        type="button"
                        className="btn-link"
                        onClick={resendOTP}
                    >
                        Resend
                    </button>
                </p>
            )}

            <p className="note">
                If you do not see the email in your inbox, kindly check the Spam
                folder and mark it as “Not Spam” to avoid missing further
                instructions.
            </p>
            <div></div>
        </>
    );
};

const mapStateToProps = (store) => ({
    currentStep: store.signupReducer.currentStep,
    basicData: get(store, 'signupReducer.basicData'),
});
const mapDispatchToProps = {
    resendBusinessOTPRequest,resendOTPRequest
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'otpform', // a unique identifier for this form
    })(OtpForm)
);
